import Joi from 'joi';
export const SWAG_BUNDLES_NAME_MAX_LENGTH = 9999;
const schema = Joi.object().keys({
  name: Joi.string().min(1).max(SWAG_BUNDLES_NAME_MAX_LENGTH).required()
}).unknown();
export const validateSwagBundlesNaming = ({
  editing: data
}) => {
  return schema.validate(data);
};